// disable max lines since this is just data
/* eslint-disable max-lines */
export const CONTENT_HOURS_BY_LEARN_LANG_MAPPING: { [key: string]: { [key: string]: number }} = {
  DAN: {
    en_GB: 65,
    en: 65,
    de: 60,
    es: 35,
    fr: 35,
    it: 35,
    pt: 35,
    sv: 35
  },
  DEU: {
    en_GB: 150,
    en: 150,
    es: 150,
    fr: 150,
    it: 150,
    pt: 110,
    sv: 110,
    pl: 55,
    uk: 30
  },
  ENG: {
    de: 190,
    es: 180,
    fr: 180,
    it: 180,
    pt: 130,
    sv: 130,
    pl: 80,
    uk: 25
  },
  FRA: {
    en_GB: 150,
    en: 150,
    de: 150,
    es: 150,
    it: 150,
    pt: 120,
    sv: 100
  },
  IND: {
    en_GB: 50,
    en: 50,
    de: 50,
    es: 35,
    fr: 35,
    it: 35,
    pt: 35,
    sv: 35
  },
  ITA: {
    en_GB: 130,
    en: 130,
    de: 130,
    es: 130,
    fr: 130,
    pt: 110,
    sv: 95
  },
  NLD: {
    en_GB: 80,
    en: 80,
    de: 80,
    es: 35,
    fr: 75,
    it: 35,
    pt: 35,
    sv: 35
  },
  NOR: {
    en_GB: 70,
    en: 70,
    de: 70,
    es: 35,
    fr: 35,
    it: 35,
    pt: 35,
    sv: 35
  },
  POL: {
    en_GB: 90,
    en: 90,
    de: 90,
    es: 40,
    fr: 50,
    it: 35,
    pt: 35,
    sv: 35,
    uk: 25
  },
  POR: {
    en_GB: 120,
    en: 120,
    de: 120,
    es: 120,
    fr: 120,
    it: 120,
    sv: 80
  },
  QMS: {
    en: 45
  },
  RUS: {
    en_GB: 75,
    en: 75,
    de: 75,
    es: 45,
    fr: 75,
    it: 75,
    pt: 40,
    sv: 40
  },
  SPA: {
    en_GB: 160,
    en: 170,
    de: 160,
    fr: 160,
    it: 160,
    pt: 140,
    sv: 135
  },
  SWE: {
    en_GB: 130,
    en: 130,
    de: 130,
    es: 110,
    fr: 120,
    it: 75,
    pt: 75
  },
  TUR: {
    en_GB: 90,
    en: 90,
    de: 90,
    es: 45,
    fr: 90,
    it: 45,
    pt: 45,
    sv: 45
  }
};
